import React, { Component } from 'react';
import { observer } from 'mobx-react';

const VTCReview = observer(class VTCReview extends Component {
  render() {
    return (
      // Dynamic access key
      <iframe
        className="vtc-review"
        src={`https://s3.amazonaws.com/smarterservices-static/virtual-test-center-session-playback/index.html?session=${this.props.accessCode.replace(/-/g,'')}`}
      />
    );
  }
})

export default VTCReview;



// WEBPACK FOOTER //
// ./src/app/components/VTC/Review.js